$( document ).ready(function() {

  // This is required for the out of stock app to work on the first selected variant.
  var currentVarID = $('#id').val();

  const urlParams = new URLSearchParams(window.location.search);
  let savedParams = '';
  for(const entry of urlParams.entries()) {
    if(entry[0] != 'variant'){
      savedParams = `${savedParams}&${entry[0]}=${entry[1]}`;
    }
  }
  window.history.replaceState( {} , '', '?variant='+currentVarID+savedParams );


  $('.product-form__input.set-width label').on('click', function() {
    let testFirstOption = $(this).data('value');
    var selectedTestLabels = document.querySelectorAll('.set-size label');
    for (var i = 0; i < selectedTestLabels.length; i++) {
      var nameTestItem = $(selectedTestLabels[i]).data('value');
      var testScenario = nameTestItem + ' / ' + testFirstOption;
      var testCounter = 0;
      $('#ProductSelect-product-template > option').each(function() {
        var thisOptName = $(this).text().replace(/^\s+|\s+$/g, '');
        if(thisOptName.indexOf(testScenario) > -1){
          testCounter++;
        }
      });
      if(testCounter <= 0){
        $(selectedTestLabels[i]).hide();
      } else {
        $(selectedTestLabels[i]).show();
      }
    }
  });
    
  // VARIANT SELECTOR
  $('.product-form__input label').on('click', function() {
    // add variant to url
    if ($(this).data('handle')) return window.location.assign(`/products/${ $(this).data('handle') }`);
    // on click make sure labels have selected
    $(this).parent().find('label').removeClass('selected');
    $(this).addClass('selected');
    var optname = '';
    var selectedLabels = document.querySelectorAll('.product-form__input label.selected');
    for (var i = 0; i < selectedLabels.length; i++) {
      var nameItem = $(selectedLabels[i]).data('value');
      if(i == 0){
        optname += nameItem
      } else {
        optname += ' / ' + nameItem;
      }
    }
    optname.replace(/^\s+|\s+$/g, '');
    var varid ='';
    var varinv ='';
    var varprice = '';
    // Cycle through each hidden option and check the currently selected labels agaisnt known variants. Get the id from that.
    $('#ProductSelect-product-template > option').each(function() {
      var thisOptName = $(this).text().replace(/^\s+|\s+$/g, '');
      if(thisOptName == optname){
        varid = $(this).val();
        varinv = $(this).data('inv');
        varprice = $(this).data('price');
        $('#ProductSelect-product-template > option').removeAttr('selected');
        $(this).attr('selected','selected');
        window.history.replaceState( {} , '', '?variant='+varid+savedParams ); // change url param but saves the savedParms set up above.
        $('input[name="id"]').val(varid);
        $('.price-num').html(varprice);
        console.log(varprice);
      }
    });
    // First test if the varid exists. If not, it means the option combination doesnt exist in shopify.
    if(varid == '' ){
      let cuteOptName = ' Size ' + $(selectedLabels[1]).data('value') + ' ' + $(selectedLabels[2]).data('value');
      $('.variant-doesnt-exist').html('Sorry. We do not have this product in '+ cuteOptName);
      //shut down buying
      $('.btn-product-add-to-cart').attr('disabled', 'true');
      $('.quantity__button').attr('disabled', 'true');
      $('.notice-out-of-stock').hide();
      $('.in-stock').hide();
      $('.shopify-payment-button__button').hide();
      $('.btn-product-add-to-cart span').html('Sold Out');
    } else {
      $('.variant-doesnt-exist').html('');
      // if inventory for this variant is zero disable the buy button
      if(varinv == 0){
        $('.btn-product-add-to-cart').attr('disabled', 'true');
        $('.quantity__button').attr('disabled', 'true');
        $('.notice-out-of-stock').show();
        $('.in-stock').hide();
        $('.none-in-stock').addClass('show');
        $('.shopify-payment-button__button').hide();
        $('.btn-product-add-to-cart span').html('Sold Out');
      } else {
        $('.btn-product-add-to-cart').removeAttr('disabled');
        $('.quantity__button').removeAttr('disabled', 'true');
        $('.notice-out-of-stock').hide();
        $('.in-stock').show();
        $('.none-in-stock').removeClass('show');
        $('.shopify-payment-button__button').show();
        $('.btn-product-add-to-cart span').html('Buy Now');
        if(varinv <= 13){
          $('.in-stock').html('Only <span class="num">' + varinv + '</span> in stock');
        } else {
          $('.in-stock').html('');
        }
      }
    }
    $('.variant-inventory').html(varinv);
  });

  // QUANTITY
  $('.quantity__button').on('click', function(){
    var currentValue = parseInt(document.getElementById("quantity").value);
    if($(this).hasClass('product-minus')){
      if(currentValue != 1){
        var newVal = currentValue - 1;
        $('#quantity').val(newVal);
      }
    } else {
      var newVal = currentValue + 1;
      $('#quantity').val(newVal);
    }
  });

  // Upsell on products
  $('.btn-product-add-to-cart.push-first').on('click', function(event){
    event.preventDefault();

    var productId = $('#id').val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: 1,
          id: productId
      },
      dataType: 'json',
      success: function() {
          console.error('added!'); 

          // var pushCount = $('.ocs-product-push #productCount').data('count');
          // if(pushCount >= 1){
          //   $('.ocs-product-push').addClass('show');
          // } else {
          //   window.location = '/cart';
          // }
          window.location = '/cart';
      },
      error: function(err){ 
        console.error('Booo!', err) 
      }
    });
  });

  $(document).on({
    mouseenter: function() {
      // This event is now ready for individual container adjustments if needed.
    },
    mouseleave: function() {
      // Reset the image position on mouse leave to center, specific to this container.
      $(this).find('img').css({'transform': 'translate(0%, 0%)'});
    },
    mousemove: function(event) {
      var $targetFrame = $(this); // Now targeting the specific hover-zoom container.
      var objOffset = $targetFrame.offset();
      var targetWidth = $targetFrame.width();
      var targetHeight = $targetFrame.height();
  
      var offsetX = event.pageX - objOffset.left;
      var offsetY = event.pageY - objOffset.top;
  
      // Calculate the mouse position percentage relative to this container.
      var mouseXPercentage = offsetX / targetWidth;
      var mouseYPercentage = offsetY / targetHeight;
  
      // Calculate translation values based on mouse position, specific to this container's dimensions.
      var translateX = ((mouseXPercentage - 0.5) * 2 * -40) - 20;
      var translateY = ((mouseYPercentage - 0.5) * 2 * -50) - 30;
  
      // Apply the calculated translation to the image within the currently hovered container.
      $targetFrame.find('img').css({'transform': `translate(${translateX}%, ${translateY}%)`});
    }
  }, '.hover-zoom'); // This selector remains the same, targeting all elements with the hover-zoom class.
 
 
});

$(window).on("load resize",function(e){
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  var browserWidth = $(window).width();
  if(check == false && browserWidth >= 1000 ){
    $('.gallery-viewer .frame').addClass('hover-zoom');
  } else {
    $('.gallery-viewer .frame').removeClass('hover-zoom');
  }
});